/* eslint-disable */
<template>
  <div class="h-screen flex w-full bg-img" id="page-login">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-1/4 mx-auto self-center">
      <vx-card>
        <div>
          <div class="vx-row">
<!--            <div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center">-->
<!--              <img src="@/assets/images/pages/login.png" alt="login" class="mx-auto">-->
<!--            </div>-->
            <div class="vx-col sm:w-full md:w-full lg:w-full mx-auto self-center d-theme-dark-bg">
              <div class="p-8">
                <div class="vx-card__title mb-8">
                  <h4 class="mb-4">I9 Advisory - Sistema de Crédito</h4>
                  <p>Bem vindo.</p>
                </div>
                <vs-input
                  name="email"
                  icon="icon icon-user"
                  icon-pack="feather"
                  label-placeholder="Email"
                  v-model="email"
                  class="w-full no-icon-border"
                  v-on:keyup.enter="login"/>

                <vs-input
                  type="password"
                  name="password"
                  icon="icon icon-lock"
                  icon-pack="feather"
                  label-placeholder="Senha"
                  v-model="password"
                  class="w-full mt-6 no-icon-border"
                  v-on:keyup.enter="login"/>

                <vs-alert v-if="error" color="danger" active="true" class="my-5">
                  <div class="flex">&nbsp;{{ error }}</div>
                </vs-alert>

                <div class="flex flex-wrap justify-between mt-5">
                  <vs-checkbox v-model="checkbox_remember_me" class="mb-3">Continuar conectado</vs-checkbox>
                </div>

                <div class="flex mb-5 float-right">
                  <vs-button @click="recoverPassword">Esqueci a senha</vs-button>
                  <vs-button class="ml-2" @click="login">Login</vs-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  data () {
    return {
      email: '',
      password: '',
      checkbox_remember_me: false,
      error: null
    }
  },
  methods: {
    recoverPassword () {
      this.error = null

      const regex = /\\S+@\\S+\\.\\S+/

      if (regex.test(this.email)) {
        this.error = 'E-mail inválido.'
        return
      }

      const emailForm = {
        'email': this.email
      }

      this.loading = true
      const url = `${process.env.VUE_APP_AUTH_API}/api/v1/password-recovery`

      axios.post(url, emailForm)
        .then((response) => {
          if (response) {
            if (response.status === 201) {
              this.error = 'E-mail enviado'
            }
          }
        })
        .catch(() => {
          this.error = 'Erro. Tente novamente mais tarde.'
        })
    },
    login () {
      const loginForm = {
        'username': this.email,
        'password': this.password
      }

      this.error = null

      this.loading = true
      const url = `${process.env.VUE_APP_AUTH_API  }/login`


      axios.post(url, loginForm)
        .then((response) => {
          if (response) {
            if (response.status === 200) {
              this.loadUser()
              localStorage.token = response.headers['authorization']
            }
          }
        })
        .catch(() => {
          this.loginFailed()
        })
    },
    loginFailed () {
      this.error = 'Não foi possível a autenticação do usuário.'
      delete localStorage.token
      delete localStorage.currentUser
    },
    loadUser () {
      const url = `${process.env.VUE_APP_AUTH_API  }/api/v1/users/me`

      localStorage.currentUser = JSON.stringify({'email': null, 'name': null, 'lastName': null, 'profile': null, 'roles': [], 'tenantType': null})
      let status

      axios.get(url)
        .then((response) => {
          if (response) {
            if (response.status === 200) {
              status = response.status
              localStorage.currentUser = JSON.stringify(response.data)
            }
          }
        })
        .finally(() => {
          if (status === 200) {
            this.error = false
            if (this.$route.query.from) {
              this.$router.replace(this.$route.query.from)
            } else {
              this.$router.push({ path: '/' })
            }
          }
        })
    }
  }
}
</script>

<style lang="scss">
  #page-login {
    .social-login {
      .bg-facebook {
        background-color: #1551b1;
      }
      .bg-twitter {
        background-color: #00aaff;
      }
      .bg-google {
        background-color: #1551b1;
      }
      .bg-github {
        background-color: #333;
      }
    }
  }
</style>
